import XyInput from './input';

/* istanbul ignore next */
XyInput.install = function(Vue) {
  Vue.component(XyInput.name, XyInput);
};

export default XyInput;
